import { useEntity } from "apps/console/context/entity";
import { useGetListSponsoringOrganizationsForParticipant } from "apps/console/modules/registration/approval/details/dataloader";
import { useFormikContext } from "formik";
import React from "react";
import FormMultiSelectField from "shared/form/fields/multiSelectField";
import { FormFieldOption } from "shared/form/fields/types";
import { useDynamicFormRenderer } from "../../context/dynamicFormRendererContext";
import DynamicFieldConfigType from "../../types/DynamicFieldConfigType";
import DynamicFieldLabel from "../DynamicFieldLabel";
import { useGetListSponsoringOrganizationsForRegistration } from "shared/dataloader";

export default function FormCommunitySponsorField(props: DynamicFieldConfigType) {
  // todo: rd - framework should be able to handle the params required to fetch from api and which api to call
  const { registrationParticipantId, registrationFormId } = useDynamicFormRenderer();
  const { setFieldValue } = useFormikContext();
  const { registrationId } = useEntity();

  const showCommunitySponsorAttachedToRegistrationForm = React.useMemo(
    () => Boolean(registrationParticipantId && registrationFormId),
    [registrationFormId, registrationParticipantId]
  );

  const { data: allCommunitySponsors = [] } = useGetListSponsoringOrganizationsForRegistration({
    registrationId: showCommunitySponsorAttachedToRegistrationForm ? undefined : registrationId
  });

  const { data: formCommunitySponsors = [] } = useGetListSponsoringOrganizationsForParticipant({
    registrationFormId,
    registrationParticipantId,
    successHandler: data => {
      if (Array.isArray(props.schemaObj.value)) {
        const selectedValue = props.schemaObj.value?.filter(item => !!data.find(d => d.id === item));
        // Clearing community sponsor ids which are not attached to given registration form
        setFieldValue(props.schemaObj.id, selectedValue);
      }
    }
  });

  const options: Array<FormFieldOption> = React.useMemo(() => {
    const communitySponsors = showCommunitySponsorAttachedToRegistrationForm
      ? formCommunitySponsors
      : allCommunitySponsors;
    return communitySponsors.map(cs => {
      return { label: cs.name, value: cs.id };
    });
  }, [allCommunitySponsors, formCommunitySponsors, showCommunitySponsorAttachedToRegistrationForm]);

  return (
    <React.Fragment>
      <FormMultiSelectField
        name={props.schemaObj.id}
        label={<DynamicFieldLabel schemaObj={props.schemaObj} />}
        required={props.schemaObj.mandatory}
        disabled={props.schemaObj.disabled}
        options={options}
        validate={props.validationFn}
        fullWidth={props.schemaObj.fullWidthView}
        indented={props.schemaObj.indented}
      />
    </React.Fragment>
  );
}
